import { Loader2 } from "lucide-react";
import { Link } from "react-router-dom";

export function Loading({ label = "Loading" }) {
  return (
    <div data-testid="loading-state" className="flex items-center justify-center py-32 text-muted-foreground">
      <Loader2 className="h-5 w-5 animate-spin mr-2" /> {label}…
    </div>
  );
}

export function EmptyState({ title = "Nothing here yet", description, action }) {
  return (
    <div data-testid="empty-state" className="text-center py-24">
      <h3 className="font-heading text-xl font-semibold text-ink">{title}</h3>
      {description && <p className="text-muted-foreground mt-2 max-w-md mx-auto">{description}</p>}
      {action}
    </div>
  );
}

export function NotFound() {
  const links = [["/", "Home"], ["/gameday", "Browse GameDay"], ["/venues", "Venues"], ["/guides", "Guides"]];
  return (
    <div data-testid="not-found" className="mx-auto max-w-2xl px-5 sm:px-8 py-28 text-center">
      <div className="overline text-primary mb-3">404</div>
      <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-ink">Page not found</h1>
      <p className="text-muted-foreground mt-4 max-w-md mx-auto leading-relaxed">
        We couldn't find that page. It may have moved, or the event may have already taken place.
        Try one of these instead:
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        {links.map(([to, label]) => (
          <Link key={to} to={to} data-testid={`notfound-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className="inline-flex items-center rounded-full border border-black/15 px-5 py-2.5 text-sm font-heading font-semibold text-ink hover:border-primary hover:text-primary transition-colors">
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
}
